export enum EscriptOnboardingStepName {
  redirect = 'redirect',
  welcome = 'welcome',
  how_it_works = 'how_it_works',
  insurance = 'insurance',
  allergies = 'allergies',
  other_meds = 'other_meds',
  other_meds_yes = 'other_meds_yes',
  manage_your_meds = 'manage_your_meds',
  say_capsule = 'say_capsule',
  any_doctor_any_med = 'any_doctor_any_med',
  end = 'end',
}
